// @see https://sunstonecreditinc.atlassian.net/browse/SUNENG-2205
import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import { Ruleset } from '../../interfaces/Ruleset';
import { RulesetResult } from '../rules';

class PgExtension2YearsAgoRuleset implements Ruleset {
  private principalId: any;

  public setPrincipalId(id: any) {
    this.principalId = id;
    return this;
  }
  public evaluate = (data: Partial<ApplicationFormValues>): RulesetResult => {
    // This is not being required right now in the current flow, but leaving the code in place to save time in the future
    return RulesetResult.HIDDEN;
  };
}

export default new PgExtension2YearsAgoRuleset();
